const states = [
  { id: 1, name: "Alabama", code: "AL" },
  { id: 2, name: "Alaska", code: "AK" },
  { id: 3, name: "Arizona", code: "AZ" },
  { id: 4, name: "Arkansas", code: "AR" },
  { id: 5, name: "California", code: "CA" },
  { id: 6, name: "Colorado", code: "CO" },
  { id: 7, name: "Connecticut", code: "CT" },
  { id: 8, name: "Delaware", code: "DE" },
  { id: 9, name: "District of Columbia", code: "DC" },
  { id: 10, name: "Florida", code: "FL" },
  { id: 11, name: "Georgia", code: "GA" },
  { id: 12, name: "Hawaii", code: "HI" },
  { id: 13, name: "Idaho", code: "ID" },
  { id: 14, name: "Illinois", code: "IL" },
  { id: 15, name: "Indiana", code: "IN" },
  { id: 16, name: "Iowa", code: "IA" },
  { id: 17, name: "Kansas", code: "KS" },
  { id: 18, name: "Kentucky", code: "KY" },
  { id: 19, name: "Louisiana", code: "LA" },
  { id: 20, name: "Maine", code: "ME" },
  { id: 21, name: "Maryland", code: "MD" },
  { id: 22, name: "Massachusetts", code: "MA" },
  { id: 23, name: "Michigan", code: "MI" },
  { id: 24, name: "Minnesota", code: "MN" },
  { id: 25, name: "Mississippi", code: "MS" },
  { id: 26, name: "Missouri", code: "MO" },
  { id: 27, name: "Montana", code: "MT" },
  { id: 28, name: "Nebraska", code: "NE" },
  { id: 29, name: "Nevada", code: "NV" },
  { id: 30, name: "New Hampshire", code: "NH" },
  { id: 31, name: "New Jersey", code: "NJ" },
  { id: 32, name: "New Mexico", code: "NM" },
  { id: 33, name: "New York", code: "NY" },
  { id: 34, name: "North Carolina", code: "NC" },
  { id: 35, name: "North Dakota", code: "ND" },
  { id: 36, name: "Ohio", code: "OH" },
  { id: 37, name: "Oklahoma", code: "OK" },
  { id: 38, name: "Oregon", code: "OR" },
  { id: 39, name: "Pennsylvania", code: "PA" },
  { id: 40, name: "Rhode Island", code: "RI" },
  { id: 41, name: "South Carolina", code: "SC" },
  { id: 42, name: "South Dakota", code: "SD" },
  { id: 43, name: "Tennessee", code: "TN" },
  { id: 44, name: "Texas", code: "TX" },
  { id: 45, name: "Utah", code: "UT" },
  { id: 46, name: "Vermont", code: "VT" },
  { id: 47, name: "Virginia", code: "VA" },
  { id: 48, name: "Washington", code: "WA" },
  { id: 49, name: "West Virginia", code: "WV" },
  { id: 50, name: "Wisconsin", code: "WI" },
  { id: 51, name: "Wyoming", code: "WY" },
];

export default states;
